import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PktrAppMenuService } from '@prospektr/pktr-app-menu';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Json } from 'src/app/_shared/interface/common.interface';
import { AppState } from 'src/app/app.state';
import { LoginFieldInputErrorCheck } from 'src/app/login/login.interface';
import { ValidatorsService } from 'src/app/shared/service/validators.service';
import { ClientDashboardService } from '../../service/client-dashboard.service';
import { ClientDashboardState } from '../../state/client-dashboard.state';

@Component({
  selector: 'app-add-contact-note-sheet',
  templateUrl: './add-contact-note-sheet.component.html',
  styleUrls: ['./add-contact-note-sheet.component.scss'],
})
export class AddContactNoteSheetComponent implements OnInit {
  openAddContactNoteSheetValue: any;
  onDestroyNotifier$ = new Subject();
  adContactNoteForm: any;
  dialogRef: any;
  addContactSheetContext: any;
  patterns: LoginFieldInputErrorCheck;
  isLoading: boolean = false;
  isNameDisabled = false;
  address: any;
  showSecondClient = false;
  showSecondOwner = false;
  emailList = [];
  selectedEmails: string[] = [];
  disabledEmails: any;
  subscribedEmails = [];
  selectedEmailList: string[] = [];

  constructor(
    private clientDashboardState: ClientDashboardState,
    private clientDashboardService: ClientDashboardService,
    private formBuilder: FormBuilder,
    private validators: ValidatorsService,
    private dialog: MatDialog,
    private appState: AppState,
    private snackBar: MatSnackBar,
    public breakpointService: ValidatorsService,
    public _pktrAppMenuService: PktrAppMenuService,
  ) { }

  ngOnInit(): void {
    this.breakpointService
      .isMobileOrTablet()
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((isMobileOrTablet) => {
        if (isMobileOrTablet) {
          this._pktrAppMenuService.close(true);
        }

      });

    this.patterns = this.validators.patterns;
    this.adContactNoteForm = this.formBuilder.group({
      //  name: [''],
      clientOneName: [''],
      clientOneEmail: ['', [Validators.email, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      clientOnePhoneNumber: [''],
      clientTwoName: [''],
      clientTwoEmail: ['', [Validators.email, Validators.pattern(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)]],
      clientTwoPhoneNumber: [''],
      currentOwnerOneName: [''],
      currentOwnerOneEmail: [''],
      currentOwnerTwoName: [''],
      currentOwnerTwoEmail: [''],
      // email: ['', [Validators.email]],
      phoneNumber: ['', Validators.pattern(/^\d{10}$/)],
      note: [''],
      address: [''],
    });

    this.clientDashboardState.openAddContactNoteSheet$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((status) => {
      this.openAddContactNoteSheetValue = status;
    });

    this.adContactNoteForm.valueChanges.subscribe(() => {
      this.updateEmailList();
    });
    this.clientDashboardState.addContactSheetContext$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((context) => {
      this.addContactSheetContext = context?.data;
      this.adContactNoteForm.patchValue({
        email: this.addContactSheetContext?.email,
        phoneNumber: this.addContactSheetContext?.phone,
        note: Array.isArray(this.addContactSheetContext?.note)
          ? this.addContactSheetContext.note[this.addContactSheetContext.note.length - 1]
          : this.addContactSheetContext?.note ?? '',
        address: this.addContactSheetContext?.address,
        clientOneName: this.addContactSheetContext?.clientOneFirstName
          ? this.addContactSheetContext?.clientOneFirstName + ' ' + this.addContactSheetContext?.clientOneLastName
          : '',
        clientOneEmail: this.addContactSheetContext?.clientOneEmail,
        clientOnePhoneNumber: this.addContactSheetContext?.clientOnePhoneNumber,
        clientTwoName: this.addContactSheetContext?.clientTwoFirstName
          ? this.addContactSheetContext?.clientTwoFirstName + ' ' + this.addContactSheetContext?.clientTwoLastName
          : '',
        clientTwoEmail: this.addContactSheetContext?.clientTwoEmail,
        clientTwoPhoneNumber: this.addContactSheetContext?.clientTwoPhoneNumber,
        currentOwnerOneName: this.addContactSheetContext?.currentOwnerOneFirstName
          ? this.addContactSheetContext?.currentOwnerOneFirstName +
          ' ' +
          this.addContactSheetContext?.currentOwnerOneLastName
          : '',
        currentOwnerOneEmail: this.addContactSheetContext?.currentOwnerOneEmail,
        currentOwnerTwoName: this.addContactSheetContext?.currentOwnerTwoFirstName
          ? this.addContactSheetContext?.currentOwnerTwoFirstName +
          ' ' +
          this.addContactSheetContext?.currentOwnerTwoLastName
          : '',
        currentOwnerTwoEmail: this.addContactSheetContext?.currentOwnerTwoEmail,
        //  clientName: this.addContactSheetContext?.clientName,
      });
    });

    if (this.emailList.length != 0) {
      let params = {
        email: this.emailList,
        companyId: this.appState.companyInfoValue.id,
        pmxPropertyId: this.addContactSheetContext?.PMXPropertyId,
      };
      this.clientDashboardService.getAutomatedCampSubscriptions(params).subscribe({
        next: (res: any) => {
          this.subscribedEmails = res.data || [];
          if (this.subscribedEmails.length === 1) {
            this.selectedEmailList = [...this.subscribedEmails];
          }
          if (res.data && res.data.length > 0) {
            this.disabledEmails = res.data.map((x: any) => (typeof x === 'string' ? x : x.email));
            this.selectedEmails = [...this.disabledEmails];
          }
        },
        error: (err: any) => {
          console.log(err, 'errr');
        },
      });
    }
  }

  updateEmailList() {
    const emailFields = ['clientOneEmail', 'clientTwoEmail', 'currentOwnerOneEmail', 'currentOwnerTwoEmail'];
    const formEmails = emailFields.map((field) => this.adContactNoteForm.get(field)?.value?.trim()).filter(Boolean);
    const combined =
      this.disabledEmails && this.disabledEmails.length ? [...this.disabledEmails, ...formEmails] : [...formEmails];
    this.emailList = [...new Set(combined)];
    if (this.emailList.length === 1) {
      this.selectedEmails = [...this.emailList];
    }
  }

  get email() {
    return this.adContactNoteForm.get('email');
  }

  updateContactNoteSheet(source?: string) {
    this.ignorePairErrors();
    if (this.adContactNoteForm.invalid) {
      return;
    }
    this.clientDashboardService.updateContactNoteSheet(this.adContactNoteForm.value, source).subscribe((res: any) => {
      this.isLoading = res?.isLoading;
    });
  }

  ignorePairErrors() {
    Object.keys(this.adContactNoteForm.controls).forEach((key) => {
      const control = this.adContactNoteForm.get(key);
      if (control?.errors?.pairRequired) {
        const errors = { ...control.errors };
        delete errors.pairRequired;
        control.setErrors(Object.keys(errors).length ? errors : null);
      }
    });
  }

  closeAddContactSheet() {
    this.adContactNoteForm.reset();
    this.addContactSheetContext = null;
    this.clientDashboardState.openAddContactNoteSheetValue = false;
  }

  getAddressComponentsFromStandardAddress(standardAddress: string): Json {
    let addressComponentList = standardAddress?.split(',');
    if (!addressComponentList || addressComponentList?.length < 3) return null;
    let stateAndZip = addressComponentList[2];
    let stateAndZipList = stateAndZip?.split(' ');
    let addressComponent: any = {
      StreetAddress: addressComponentList[0],
      City: addressComponentList[1],
      State: stateAndZipList[1],
      PostalCode: stateAndZipList[2],
    };
    return addressComponent;
  }

  openDialog(template: TemplateRef<any>) {
    const pairs = [
      { name: 'clientOneName', email: 'clientOneEmail' },
      { name: 'clientTwoName', email: 'clientTwoEmail' },
      { name: 'currentOwnerOneName', email: 'currentOwnerOneEmail' },
      { name: 'currentOwnerTwoName', email: 'currentOwnerTwoEmail' },
    ];

    const controls = pairs.map((p) => ({
      nameCtrl: this.adContactNoteForm.get(p.name),
      emailCtrl: this.adContactNoteForm.get(p.email),
    }));

    let hasError = false;
    // ✅ Step 1: Check if ANY email exists
    const hasAnyEmail = controls.some((c) => c.emailCtrl?.value?.trim());
    controls.forEach((c) => {
      const name = c.nameCtrl?.value?.trim();
      const email = c.emailCtrl?.value?.trim();
      c.nameCtrl?.setErrors(null);
      c.emailCtrl?.setErrors(null);
      const isAllEmpty = controls.every((c) => {
        const name = c.nameCtrl?.value?.trim();
        const email = c.emailCtrl?.value?.trim();
        return !name && !email;
      });
      if (isAllEmpty) {
        c.nameCtrl?.setErrors({ required: true });
        c.emailCtrl?.setErrors({ required: true });
        hasError = true;
        return;
      }

      // ✅ Case 1: Email exists but no name → always error
      if (email && !name) {
        c.nameCtrl?.setErrors({ pairRequired: true });
        c.nameCtrl?.markAsTouched();
        hasError = true;
      }
      // ✅ Case 2: Name exists but no email
      if (name && !email) {
        if (!hasAnyEmail) {
          c.emailCtrl?.setErrors({ pairRequired: true });
          c.emailCtrl?.markAsTouched();
          hasError = true;
        }
      }
    });

    if (hasError) {
      return;
    }
    this.dialogRef = this.dialog.open(template, {
      width: '400px',
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  deleteSubscription(template1: TemplateRef<any>) {
    this.dialogRef = this.dialog.open(template1, {
      width: '400px',
    });
  }

  submitCampaign() {
    const selected = this.selectedEmails || [];
    const disabled = this.disabledEmails || [];

    const emailsToSend = selected.filter((e) => !disabled.includes(e));
    if (selected.length === 0) {
      this.openSnackBar('Email is Required', 'snackbar-error');
      return;
    }
    if (selected.length > 0 && emailsToSend.length === 0) {
      this.openSnackBar('Email is already subscribed', 'snackbar-error');
      return;
    }
    const payload = emailsToSend.map((email) => {
      let finalEmail = email;
      let nameValue = '';
      let phoneValue;
      const emailMap = [
        { email: 'clientOneEmail', name: 'clientOneName', phone: 'clientOnePhoneNumber' },
        { email: 'clientTwoEmail', name: 'clientTwoName', phone: 'clientTwoPhoneNumber' },
        { email: 'currentOwnerOneEmail', name: 'currentOwnerOneName' },
        { email: 'currentOwnerTwoEmail', name: 'currentOwnerTwoName' },
      ];
      const match = emailMap.find((item) => email === this.adContactNoteForm.get(item.email)?.value);
      if (match) {
        nameValue = this.adContactNoteForm.get(match.name)?.value;
        finalEmail = this.adContactNoteForm.get(match.email)?.value;
        if (match.phone) {
          phoneValue = this.adContactNoteForm.get(match.phone)?.value;
        }
      }
      const split = this.splitName(nameValue || '');
      return {
        companyId: this.appState.companyInfoValue.id,
        pmxPropertyId: this.addContactSheetContext?.PMXPropertyId,
        address: this.addContactSheetContext.address,
        phone: phoneValue,
        city: this.addContactSheetContext?.city,
        state: this.addContactSheetContext?.state,
        zip: this.addContactSheetContext?.zip,
        streetAddress: this.addContactSheetContext?.streetAddress,
        email: finalEmail,
        firstName: split.firstName,
        lastName: split.lastName,
      };
    });

    this.clientDashboardService.launchPastClientAutomatedCampaign(payload).subscribe({
      next: (res: any) => {
        if (res.message) {
          this.openSnackBar(res.message, 'snackbar-success');
          this.updateContactNoteSheet('autoMarketing');
        }
      },
      error: (err: any) => {
        console.error(err, 'error');
      },
    });
    this.dialogRef.close();
  }

  unsubscribeMarketing() {
    const params = {
      source: 'pastClient',
      email: this.selectedEmailList,
    };
    this.clientDashboardService.unsubscribeMarketing(params).subscribe({
      next: (res: any) => {
        this.openSnackBar('Unsubscribed Successfully', 'snackbar-success');
        this.closeDialog();
      },
      error: (err: any) => {
        console.error(err, 'error');
        this.openSnackBar('Failed to Unsubscribe', 'snackbar-error');
      },
    });
  }

  splitName(fullName?: string) {
    if (!fullName) return {};
    const parts = fullName.trim().split(' ');
    return {
      firstName: parts[0] || '',
      lastName: parts.slice(1).join(' ') || '',
    };
  }

  openSnackBar(message, style) {
    if (message) {
      this.snackBar.open(message, '', {
        duration: 3000,
        panelClass: [style ? style : ''],
        verticalPosition: 'top',
      });
    }
  }
}
